import { createApiRef } from '@backstage/core-plugin-api';
import type {
  EnvDetailV0,
  EnvOverviewV0,
  FeatureFlagMatrixV0Wire,
  IpGatewayInventoryV0Wire,
} from '@internal/plugin-environments-common';

export interface EnvironmentsApi {
  getMatrix(): Promise<FeatureFlagMatrixV0Wire>;
  getIpGateways(): Promise<IpGatewayInventoryV0Wire>;
  getOverview(): Promise<EnvOverviewV0>;
  getEnv(name: string): Promise<EnvDetailV0>;
}

export const environmentsApiRef = createApiRef<EnvironmentsApi>({
  id: 'plugin.environments.service',
});
